








import Vue from 'vue'
import SignalIcon from '@/components/SignalIcon'
import './SignalDisplay.scss'

export default Vue.extend({
  name: 'SignalDisplay',
  props: {
    score: {
      type: Number,
      default: 0,
      required: true
    }
  },
  components: {
    SignalIcon
  }
})
